var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilityPole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 32L488 32C474.745 32 464 42.745 464 56V64H432V56C432 42.745 421.255 32 408 32H408C394.745 32 384 42.745 384 56V64H288V16C288 7.163 280.837 0 272 0H240C231.163 0 224 7.163 224 16V64H128V56C128 42.745 117.255 32 104 32H104C90.745 32 80 42.745 80 56V64H48V56C48 42.745 37.255 32 24 32H24C10.745 32 0 42.745 0 56V96C0 113.673 14.327 128 32 128H83.156L224 221.896V512H288V221.896L428.844 128H480C497.673 128 512 113.673 512 96V56C512 42.745 501.255 32 488 32ZM140.844 128H224V183.438L140.844 128ZM288 128H371.156L288 183.438V128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityPole);
export default __webpack_public_path__ + "static/media/utility-pole.2f3ec2de5bfa7664df5414f2718535cb.svg";
export { ForwardRef as ReactComponent };